/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A navigation solution for VDK Web. (@accedo/vdkweb-navigation) 6.2.5
* 
*******************************************************************************/
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _navigationHelpers = require("./navigationHelpers");
var _fnsMap;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var noop = function noop() {};
var EventType = {
  ChangeFocus: 'ChangeFocus',
  Click: 'Click',
  ContinueNavigation: 'ContinueNavigation',
  MarkFocus: 'MarkFocus',
  NavigateFocus: 'NavigateFocus',
  TraceFocus: 'TraceFocus'
};
var getInitialData = function getInitialData() {
  return {
    click: false,
    clickId: 0,
    creatingTrail: false,
    currentFocus: '',
    currentTraceFocus: '',
    lastFocus: '',
    lastNavigation: '',
    lastFocusOnNavigation: '',
    navigateFocus: '',
    persistTrail: false,
    trail: null
  };
};
var data = getInitialData();
var listeners = new Map();
var Selectors = {
  CurrentFocusChanged: '[[:current-focus-changed:]]',
  TrailBuilt: '[[:trail-built:]]'
};
var getClonedData = function getClonedData() {
  var clonedData = _objectSpread({}, data);
  if (clonedData.trail) {
    clonedData.trail = _toConsumableArray(clonedData.trail);
  }
  return clonedData;
};
var callListenersWithData = function callListenersWithData(id, prevData) {
  (listeners.get(id) || []).forEach(function (fn) {
    fn(data, prevData);
  });
};
var traceFocusFn = function traceFocusFn(traceFocus) {
  var prevData = getClonedData();
  data.navigateFocus = traceFocus ? data.navigateFocus : '';
  data.click = false;
  data.currentTraceFocus = traceFocus;
  callListenersWithData(data.currentTraceFocus, prevData);
};
var markFocusFn = function markFocusFn(_ref) {
  var focusId = _ref.focusId,
    parentId = _ref.parentId;
  if (data.creatingTrail) {
    if (data.persistTrail) {
      data.trail.push(focusId);
    }
    callListenersWithData(parentId);
  } else {
    if (data.persistTrail) {
      data.trail = [focusId];
    }
    data.creatingTrail = true;
    callListenersWithData(parentId);
    data.creatingTrail = false;
    callListenersWithData(Selectors.TrailBuilt);
  }
  data.currentTraceFocus = '';
};
var changeFocusFn = function changeFocusFn(payload) {
  var prevData = getClonedData();
  var currentFocus = payload;
  if (typeof currentFocus !== 'string') {
    console.warn("Invalid focus id passed, it must be a string:", currentFocus);
    currentFocus = '';
  }
  data.nextFocus = '';
  data.lastFocus = data.currentFocus || '';
  data.currentFocus = currentFocus;
  data.click = false;
  data.navigateFocus = '';
  data.currentTraceFocus = '';
  if (prevData.currentFocus !== data.currentFocus) {
    callListenersWithData(prevData.currentFocus, prevData);
    callListenersWithData(Selectors.CurrentFocusChanged, prevData);
  }
  callListenersWithData(data.currentFocus, prevData);
};
var navigateFocusFn = function navigateFocusFn(payload) {
  var prevData = getClonedData();
  if (!data.currentFocus && data.lastFocus) {
    data.currentTraceFocus = '';
    data.currentFocus = data.lastFocus;
    return;
  }
  data.currentTraceFocus = '';
  data.navigateFocus = payload;
  data.lastNavigation = payload;
  data.lastFocusOnNavigation = data.currentFocus;
  callListenersWithData(data.currentFocus, prevData);
};
var continueNavigationFn = function continueNavigationFn(payload) {
  var prevData = getClonedData();
  data.currentTraceFocus = '';
  data.navigateFocus = payload;
  callListenersWithData(data.currentFocus, prevData);
};
var clickFn = function clickFn() {
  var clickId = data.clickId + 1;
  var prevData = getClonedData();
  data.click = true;
  data.clickId = clickId;
  data.currentTraceFocus = '';
  data.navigateFocus = '';
  callListenersWithData(data.currentFocus, prevData);
};
var fnsMap = (_fnsMap = {}, _defineProperty(_fnsMap, EventType.ChangeFocus, changeFocusFn), _defineProperty(_fnsMap, EventType.Click, clickFn), _defineProperty(_fnsMap, EventType.ContinueNavigation, continueNavigationFn), _defineProperty(_fnsMap, EventType.MarkFocus, markFocusFn), _defineProperty(_fnsMap, EventType.NavigateFocus, navigateFocusFn), _defineProperty(_fnsMap, EventType.TraceFocus, traceFocusFn), _fnsMap);
var navigationService = {
  listenToFocusEvent: function listenToFocusEvent() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      id = _ref2.id,
      fn = _ref2.fn,
      _ref2$shouldWarnOnExi = _ref2.shouldWarnOnExistingId,
      shouldWarnOnExistingId = _ref2$shouldWarnOnExi === void 0 ? true : _ref2$shouldWarnOnExi;
    if (!(0, _navigationHelpers.isValidFocusId)(id)) {
      console.error("No valid id passed to the navigationService.listenToFocusEvent: ".concat(id));
      return noop;
    }
    if (typeof fn !== 'function') {
      console.error("No function provided for id: ".concat(id));
      return noop;
    }
    if (listeners.get(id)) {
      if (shouldWarnOnExistingId) {
        console.warn("The id: ".concat(id, " already has a registered listener in the navigationService"));
      }
    } else {
      listeners.set(id, []);
    }
    var idListeners = listeners.get(id);
    idListeners.push(fn);
    return function () {
      navigationService.unlistenToFocusEvent({
        id: id,
        fn: fn
      });
    };
  },
  unlistenToFocusEvent: function unlistenToFocusEvent(_ref3) {
    var id = _ref3.id,
      fn = _ref3.fn;
    if (!(0, _navigationHelpers.isValidFocusId)(id)) {
      console.error("No valid id passed to the navigationService.removeEventListener: ".concat(id));
      return;
    }
    if (!listeners.get(id)) {
      console.error("No listeners for this id: ".concat(id));
      return;
    }
    var idListeners = listeners.get(id);
    var newIdListeners = idListeners.filter(function (f) {
      return f !== fn;
    });
    if (newIdListeners.length === 0) {
      listeners["delete"](id);
    } else {
      listeners.set(id, newIdListeners);
    }
  },
  getData: function getData() {
    // To favor performance, not cloning the data here and expecting the
    // consumer to not mutate this
    return data;
  },
  setPersistTrail: function setPersistTrail(persistTrail) {
    data.persistTrail = persistTrail;
    if (persistTrail) {
      data.trail = [];
    } else {
      data.trail = null;
    }
  },
  resetAll: function resetAll() {
    var initialData = getInitialData();
    Object.keys(data).forEach(function (key) {
      delete data[key];
    });
    Object.keys(initialData).forEach(function (key) {
      data[key] = initialData[key];
    });
    listeners.clear();
  },
  trigger: function trigger() {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      eventType = _ref4.eventType,
      eventData = _ref4.eventData;
    if (!EventType[eventType]) {
      console.error("Wrong event passed: ".concat(eventType));
      return;
    }
    fnsMap[eventType](eventData);
  },
  EventType: EventType,
  Selectors: Selectors
};

// istanbul ignore else
if (typeof __TEST__ !== 'undefined' && __TEST__) {
  navigationService._test = {
    setDataProp: function setDataProp(prop, value) {
      data[prop] = value;
    }
  };
}
var _default = navigationService;
exports["default"] = _default;